/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Drift_SourceInputs */

const en_landing_drift_source = /** @type {(inputs: Landing_Drift_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting image, before any edit`)
};

const zh_landing_drift_source = /** @type {(inputs: Landing_Drift_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`起始原图，尚未编辑`)
};

/**
* | output |
* | --- |
* | "Starting image, before any edit" |
*
* @param {Landing_Drift_SourceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_drift_source = /** @type {((inputs?: Landing_Drift_SourceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Drift_SourceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_drift_source(inputs)
	return zh_landing_drift_source(inputs)
});
export { landing_drift_source as "landing.drift.source" }